import type { AdminRole } from '@/lib/api-admin';
import { toExportJobError, type ExportJobError } from '@/lib/exportJobs';
import type { OrderExportCriteria } from './types';

/** 엑셀 다운로드 요청·내역 권한(BE @PreAuthorize OPS_ADMIN·SUPER_ADMIN·ORDER_VIEW 중 BO 롤). */
export const ORDER_EXPORT_JOB_ROLES: ReadonlyArray<AdminRole> = ['OPS_ADMIN', 'SUPER_ADMIN'];

export const ORDER_EXPORT_JOBS_PATH = '/orders/exports';

/** 동기 export 와 같은 쿼리 키 중 반복(배열)로 보내는 것. */
const ARRAY_KEYS = new Set([
  'orderNos',
  'paymentMethods',
  'orderStatuses',
  'paymentStatuses',
  'fulfillmentStatuses',
  'pickupStatuses',
  'displayLabelCodes',
  'malls',
  'columns',
]);
const NUMBER_KEYS = new Set(['amountMin', 'amountMax', 'rowsPerFile']);

/**
 * 동기 export 쿼리(appendOrderFilterParams + 대화상자 조건) → 요청 본문(JSON).
 * BE 는 단일값·배열을 모두 받아 합치므로, 쿼리에 있는 그대로 옮긴다.
 */
export const criteriaFromQuery = (qs: URLSearchParams): OrderExportCriteria => {
  const out: OrderExportCriteria = {};
  for (const key of new Set(qs.keys())) {
    if (ARRAY_KEYS.has(key)) out[key] = qs.getAll(key);
    else if (NUMBER_KEYS.has(key)) out[key] = Number(qs.get(key));
    else out[key] = qs.get(key) ?? '';
  }
  return out;
};

// 상태·삭제 가능·크기 표시·오류 형식은 상품 엑셀과 같다(공용 lib/exportJobs).
export {
  isExportJobInProgress as isInProgress,
  canDeleteExportJob as canDeleteJob,
  formatBytes,
  ExportJobError as OrderExportError,
} from '@/lib/exportJobs';

/** BE 가 사유를 직접 적어 주는 오류 코드 — 상태별 공통 문구 대신 error.message 를 그대로 보여 준다. */
const MESSAGE_PASSTHROUGH_CODES: ReadonlySet<string> = new Set([
  'ORDER_EXPORT_RANGE_TOO_LARGE',
  'COMMON_VALIDATION_FAILED',
  'ORDER_EXPORT_JOB_NOT_FOUND',
  'ORDER_EXPORT_JOB_NOT_READY',
]);

/** 오류 응답(JSON envelope) → OrderExportError. 본문이 JSON 이 아니면 상태 코드만. */
export const toOrderExportError = (res: Response): Promise<ExportJobError> => toExportJobError(res, MESSAGE_PASSTHROUGH_CODES);
